import type { DashboardSettingsResponseDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { rebillMessageService } from '@/modules/creator-settings/rebill-messages/service/rebill-message.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider.tsx'
import { handleError } from '@/utils/error'

export function useUpdateRebillMessageHoursMutation() {
  const toast = useToast()
  const client = useQueryClient()
  const creatorId = useUnit($creatorId)
  const { settingsSortOptions } = useSettingsContext()

  return useMutation(
    (value: number) => {
      if (!creatorId) {
        throw new Error('Creator not selected')
      }

      return rebillMessageService.updateHours(creatorId, value)
    },
    {
      onMutate: (minHoursSinceLastMessage) => {
        client.setQueryData<DashboardSettingsResponseDto | undefined>(
          ['settings', creatorId, settingsSortOptions],
          (state) => {
            if (!state) return state

            return {
              ...state,
              autoMessageRebilledFansSettings: {
                ...state.autoMessageRebilledFansSettings,
                minHoursSinceLastMessage: minHoursSinceLastMessage,
              },
            }
          },
        )
      },
      onSuccess: () => {
        toast.success('Settings updated')
      },
      onError: (error) => {
        handleError(error, 'Failed to update the message hours')
        client.invalidateQueries(['settings', creatorId, settingsSortOptions])
      },
    },
  )
}
